import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export default function Signup() {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/30 p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>{t('Sign up')}</CardTitle>
          <CardDescription>
            {t('Clinician accounts are created via your hospital administrator.')}
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-3 text-sm">
          <p>
            {t(
              'If you have an invitation link, please follow it directly. Otherwise contact your hospital administrator to provision an account.',
            )}
          </p>
          <p>
            <Link to="/login" className="text-primary hover:underline">
              {t('Back to sign in')}
            </Link>
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
